import React from 'react';

import './ProductListingMobileHeaderTitle.scss';

interface Props {
  headerText: string | undefined;
}

export const ProductListingMobileHeaderTitle: React.FC<Props> = ({ headerText }) => (
  <h1 className="ProductListingMobileHeaderTitle">{headerText}</h1>
);
